import { Component } from 'react'
import PropTypes from 'prop-types'

import DropDown from 'components/DropDown'

import 'styles/components/settings/reply/ReplyEditDropDown.styl'

class ReplyEditDropDown extends Component {
  onDeleteClick = (event) => {
    event.stopPropagation()
    this.props.onDelete(this.props.replyId)
  }

  render() {
    return (
      <DropDown className="ReplyEditDropDown" onClickOutside={this.props.onClickOutside}>
        <div className="options" onClick={this.onDeleteClick}>
          Delete
        </div>
      </DropDown>
    )
  }
}

ReplyEditDropDown.propTypes = {
  replyId: PropTypes.number,
  onClickOutside: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}


export default ReplyEditDropDown



// WEBPACK FOOTER //
// ./src/scripts/components/settings/reply/ReplyEditDropDown.js